import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState';

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const veiculoReducer = (state = InitialState.veiculoReducer, action) => {
    switch (action.type) {
        case ActionType.GET_VEICULO_RESPONSE: {
            return {
                ...state,
                veiculoObject: _.assign(action.veiculoObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default veiculoReducer;